import { render } from "./GroupTools.vue?vue&type=template&id=08a8df96&scoped=true"
import script from "./GroupTools.vue?vue&type=script&lang=js"
export * from "./GroupTools.vue?vue&type=script&lang=js"

import "./GroupTools.vue?vue&type=style&index=0&id=08a8df96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a8df96"]])

export default __exports__